import { Component, OnDestroy, OnInit } from '@angular/core';
import { ShowcaseService } from 'src/app/services/header-showcase/showcase.service';

@Component({
    selector: 'app-naac-accreditation',
    templateUrl: './naac-accreditation.component.html',
    styleUrls: ['./naac-accreditation.component.scss']
})
export class NaacAccreditationComponent implements OnInit, OnDestroy {

    src: string = '/assets/pdf/about/NAAC Accreditation Certificate.pdf';
    constructor(private showcaseService: ShowcaseService) {
        this.showcaseService.hideShowcase();
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
        this.showcaseService.showingShowcase();
    }

}
